<template>
  <div class="finance-management">
    <!-- 返回按钮 -->
    <div class="back-btn" @click="backToList">
      <i class="el-icon-arrow-left"></i>返回
    </div>

    <!-- Banner区域 -->
    <div class="banner-section">
      <div class="banner-container">
        <img
            v-if="bannerImage"
            :src="baseImgUrl + bannerImage"
            class="banner-image"
        />
        <div v-else class="empty-banner">
          <i class="el-icon-picture"></i>
        </div>
      </div>
    </div>

    <!-- 业务介绍 -->
    <div class="business-intro" v-if="mode == 'intro'">
      <h3 class="section-title">业务介绍</h3>
      <div class="intro-content">{{ businessIntro }}</div>
    </div>
    <template v-if="jumpType == 1">
      <!-- 业务图片 -->
      <div class="business-images" v-if="mode == 'intro'">
        <div class="images-container">
          <div
              class="image-item"
              v-for="(image, index) in businessImages"
              :key="index"
          >
            <div class="image-wrapper" v-if="image.url">
              <img :src="baseImgUrl + image.url" class="image-preview"/>
              <p class="image-tip" @click="showProductionDetail(image)">
                查看产品<i class="el-icon-arrow-right"></i>
              </p>
            </div>
            <div v-else class="empty-image">
              <i class="el-icon-picture"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- 产品介绍 -->
      <div class="product-intro" v-if="mode == 'product'">
        <h3 class="section-title">产品介绍</h3>
        <div class="product-list">
          <div
              class="product-card"
              v-for="(product, index) in products"
              :key="index"
              :class="[product.content ? '' : 'change-h']"
          >
            <div class="product-header">
              <div class="product-info">
                <h4 class="product-title">{{ product.title }}</h4>
              </div>
              <div class="product-icon">
                <img
                    v-if="product.icon"
                    :src="baseImgUrl + product.icon"
                    class="icon-image"
                />
                <div v-else class="empty-icon">
                  <i class="el-icon-picture"></i>
                </div>
              </div>
            </div>
            <div class="product-content" v-if="product.content">
              <p class="content-text" :title="product.content">
                {{ truncateText(product.content, 50) }}
              </p>
              <el-button
                  type="text"
                  class="detail-btn"
                  @click="showProductDetail(product)"
              >查看详情
              </el-button
              >
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="jumpType == 0">
      <!-- 业务图片 -->
      <div class="business-images">
        <div class="images-container">
          <div
              class="image-item"
              v-for="(image, index) in businessImages"
              :key="index"
          >
            <img
                v-if="image.url"
                :src="baseImgUrl + image.url"
                class="image-preview"
            />
            <div v-else class="empty-image">
              <i class="el-icon-picture"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- 产品介绍 -->
      <div class="product-intro">
        <h3 class="section-title">产品介绍</h3>
        <div class="product-list">
          <div
              class="product-card"
              v-for="(product, index) in products"
              :key="index"
              :class="[product.content ? '' : 'change-h']"
          >
            <div class="product-header">
              <div class="product-info">
                <h4 class="product-title">{{ product.title }}</h4>
              </div>
              <div class="product-icon">
                <img
                    v-if="product.icon"
                    :src="baseImgUrl + product.icon"
                    class="icon-image"
                />
                <div v-else class="empty-icon">
                  <i class="el-icon-picture"></i>
                </div>
              </div>
            </div>
            <div class="product-content" v-if="product.content">
              <p class="content-text" :title="product.content">
                {{ truncateText(product.content, 50) }}
              </p>
              <el-button
                  type="text"
                  class="detail-btn"
                  @click="showProductDetail(product)"
              >查看详情
              </el-button
              >
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- 产品详情弹窗 -->
    <el-dialog
        :title="currentProduct.title"
        :visible.sync="productDetailVisible"
        width="80%"
        custom-class="product-detail-dialog"
    >
      <div class="product-detail-content">
        <div class="detail-container">
          <!-- 左侧图片区域 -->
          <div class="detail-image-container">
            <img
                v-if="currentProduct.icon"
                :src="baseImgUrl + currentProduct.icon"
                class="detail-image"
            />
            <div v-else class="empty-detail-image">
              <i class="el-icon-picture"></i>
            </div>
          </div>

          <!-- 右侧内容区域 -->
          <div class="detail-text-container">
            <div class="detail-text">
              {{ currentProduct.content }}
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="productDetailVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getServicesEntryList} from '@/API/goverment/goverment.js';

export default {
  name: 'FinanceManagement',
  components: {  },
  data() {
    return {
      baseImgUrl: process.env.VUE_APP_BASE_URL,
      bannerImage: '',
      businessIntro: '安全、便捷、高效的金融一体化服务',
      businessImages: [],
      products: [],
      productDetailVisible: false,
      currentProduct: {},
      mode: 'intro', // 'intro' 或 'product'
      jumpType: 1,
    };
  },
  created() {
    let pagekey = (this.$route.query && this.$route.query.pagekey) || '';
    this.jumpType = this.$route.query && this.$route.query.jumpType;
    if (pagekey) {
      getServicesEntryList(pagekey).then((res) => {
        if (res.code == 200 && res.data && res.data.length) {
          let bannerObj = res.data.find((item) => item.moduleKey === 'Banner');
          if (bannerObj && bannerObj.contents && bannerObj.contents.length) {
            this.bannerImage = bannerObj.contents[0].imageUrl || '';
          }

          let introduction = res.data.find(
              (item) => item.moduleKey === 'Introduction',
          );
          if (introduction && introduction.subtitle) {
            this.businessIntro = introduction.subtitle || '';
            if (introduction.contents && introduction.contents.length) {
              introduction.contents.forEach((item, index) => {
                if (item.contentType === 1 && item.imageUrl) {
                  this.businessImages.push({
                    url: item.imageUrl,
                    title: item.title || `业务图片 ${index + 1}`,
                    ...item,
                  });
                }
              });
            }
          }

          let products = res.data.find(
              (item) => item.moduleKey === 'Production',
          );
          if (products && products.contents && products.contents.length) {
            products.contents.forEach((item) => {
              if (item.contentType === 1 && item.imageUrl) {
                this.products.push({
                  title: item.title || '新产品',
                  icon: item.imageUrl,
                  content: item.subtitle || '',
                });
              }
            });
          }
        }
      });
    }
  },
  methods: {
    backToList() {
      if (this.mode === 'product') {
        this.mode = 'intro';
        return;
      } else if (this.mode === 'intro') {
        this.$router.push({name: 'serviceList'});
      }
    },
    // 文本截断方法
    truncateText(text, maxLength) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },

    // 显示产品详情
    showProductDetail(product) {
      this.currentProduct = product;
      this.productDetailVisible = true;
    },
    // 查看产品
    showProductionDetail(image) {
      this.products = [];
      if (image.linkParams && image.linkParams.pagekey) {
        this.mode = 'product';
        getServicesEntryList(image.linkParams.pagekey).then((res) => {
          if (res.code == 200 && res.data && res.data.length) {
            let products = res.data.find(
                (item) => item.moduleKey === 'Production',
            );
            if (products && products.contents && products.contents.length) {
              products.contents.forEach((item) => {
                if (item.contentType === 1 && item.imageUrl) {
                  this.products.push({
                    title: item.title || '新产品',
                    icon: item.imageUrl,
                    content: item.subtitle || '',
                  });
                }
              });
            }
          }
        });
      } else {
        this.$message({
          message: '没有配置产品',
          type: 'warning',
          offset: 100,
        });

      }
      console.log('image', image);
    },
  },
};
</script>

<style lang="less" scoped>
.finance-management {
  padding: 40px 0;
  background-color: #f8fafc;
  min-height: 100vh;
  max-width: 1200px;
  margin: 0 auto;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;

  /* 返回按钮样式 */

  .back-btn {
    display: inline-flex;
    align-items: center;
    color: #409eff;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 20px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      color: #66b1ff;
    }

    .el-icon-arrow-left {
      margin-right: 6px;
      font-size: 18px;
      font-weight: bold;
    }
  }

  /* 通用标题样式 */

  .section-title {
    font-size: 22px;
    font-weight: 600;
    color: #303133;
    text-align: center;
    margin: 60px 0 40px;
    position: relative;

    &::before {
      left: calc(50% - 100px);
    }

    &::after {
      right: calc(50% - 100px);
    }
  }

  /* Banner样式 */

  .banner-section {
    display: flex;
    justify-content: center;
  }

  .banner-container {
    height: 220px;
    width: 1200px;
    background-color: #f5f7fa;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    .banner-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .empty-banner {
      text-align: center;
      color: #c0c4cc;

      i {
        font-size: 48px;
      }
    }
  }

  /* 业务介绍样式 */

  .business-intro {
    margin-bottom: 40px;
    text-align: center;

    .intro-content {
      font-size: 18px;
      line-height: 1.8;
      color: #606266;
      max-width: 800px;
      margin: 0 auto;
      padding: 0 20px;
    }
  }

  /* 业务图片样式 */

  .business-images {
    margin-bottom: 40px;

    .images-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 20px;
      max-width: 930px;
      margin: 0 auto;

      .image-item {
        width: 214px;
        height: 255px;
        background-color: #f5f7fa;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;

        .image-wrapper {
          width: 100%;
          height: 100%;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;

          .image-preview {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: relative;
          }

          .image-tip {
            cursor: pointer;
            display: none;
            position: absolute;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 20px;
            align-items: center;
            gap: 4px;

            i {
              margin-left: 6px;
              font-size: 20px;
            }
          }

          &:hover .image-tip {
            display: flex;
          }
        }

        .empty-image {
          text-align: center;
          color: #c0c4cc;

          i {
            font-size: 48px;
          }
        }
      }
    }
  }

  /* 产品介绍样式 */

  .product-intro {
    .product-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 20px;
      max-width: 1200px;
      margin: 0 auto;

      .product-card {
        width: 320px;
        padding: 20px;
        border-radius: 8px;
        background-color: #fff;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
        border: 1px solid #ebeef5;
        display: flex;
        flex-direction: column;
        height: 470px; /* 固定高度 */

        .product-header {
          display: flex;
          margin-bottom: 16px;
          align-items: center;
          flex-direction: column;

          .product-icon {
            margin: 20px 0 10px 0;
            width: 100%;
            aspect-ratio: 1/1; /* 强制1:1宽高比 */
            background-color: #f0f7ff;
            border-radius: 8px;
            border: 1px dashed #cce0ff;
            overflow: hidden; /* 隐藏超出部分（虽然contain不会超出，但保留以防万一） */

            .icon-image {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .empty-icon {
              color: #a0c8ff;

              i {
                font-size: 32px;
              }
            }
          }
        }

        .product-info {
          flex: 1;
          min-width: 0;

          .product-title {
            font-weight: 600;
            font-size: 18px;
            color: #303133;
            margin: 0;
          }
        }

        .product-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          position: relative;
          min-height: 72px; /* 内容区域固定高度 */
          font-size: 16px;

          .content-text {
            margin: 0;
            line-height: 1.6;
            color: #606266;
            font-size: 14px;
            display: -webkit-box;
            -webkit-line-clamp: 4; /* 限制4行 */
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            flex: 1;
          }

          .detail-btn {
            align-self: flex-end;
            margin-top: auto;
            padding: 0;
            color: #409eff;
            font-size: 16px;

            & > span {
              font-size: 16px;
            }

            &:hover {
              color: #66b1ff;
            }
          }
        }
      }

      .change-h {
        height: 390px;
      }
    }
  }
}

/* 修改后的产品详情弹窗样式 */
.product-detail-dialog {
  margin-top: 10vh ;
  width: 80% !important;

  .el-dialog__header {
    .el-dialog__title {
      font-weight: bold;
      font-size: 32px;
    }
  }

  .product-detail-content {
    .detail-container {
      display: flex;
      gap: 30px;

      /* 左侧图片区域 */

      .detail-image-container {
        flex: 0 0 400px; /* 固定宽度 */
        //height: 400px;
        background-color: #f0f7ff;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #cce0ff;

        .detail-image {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }

        .empty-detail-image {
          color: #a0c8ff;
          text-align: center;

          i {
            font-size: 48px;
          }
        }
      }

      /* 右侧内容区域 */

      .detail-text-container {
        flex: 1;
        min-width: 0;

        .detail-text {
          line-height: 1.8;
          color: #606266;
          white-space: pre-line;
          font-size: 24px;
          max-height: 500px;
          height: 100%;
          overflow-y: auto;
          padding-right: 10px;
        }
      }
    }
  }

  .dialog-footer {
    text-align: center;
  }
}

/* 响应式调整 - 在小屏幕上改为上下布局 */
@media (max-width: 768px) {
  .finance-management {
    max-width: 100% !important;
    padding: 10px 0 !important;
    min-height: 100% !important;
  }

  .banner-container {
    width: 100% !important;
    height: 140px !important;
  }

  .intro-content {
    max-width: 100% !important;
    font-size: 14px !important;
  }

  .images-container {
    max-width: 100% !important;
  }

  .product-detail-dialog {
    width: 90% !important;

    .detail-container {
      flex-direction: column;

      .detail-image-container {
        flex: 0 0 auto;
        width: 100%;
        //height: 200px;
        margin-bottom: 20px;
      }
    }
  }

  /* 返回按钮样式 */
  .back-btn {
    font-size: 16px !important;

    .el-icon-arrow-left {
      font-size: 18px !important;
    }
  }

  /* 通用标题样式 */
  .section-title {
    font-size: 18px !important;
  }

  .images-container {
    gap: unset !important;
  }

  .image-item {
    padding: 10px !important;
    width: 100% !important;
    height: 100% !important;

    .image-preview {
      width: 100% !important;
      height: 100% !important;
    }

    .image-tip {
      display: block !important;
      align-items: center !important;
      width: 100% !important;
      height: 50px !important;
      line-height: 50px !important;
      text-align: center !important;
      bottom: 0 !important;
      font-size: 16px !important;

      i {
        margin-left: 6px;
        font-size: 14px !important;
      }
    }

    &:hover .image-tip {
      display: block !important;
    }
  }

  .product-list {
    max-width: 100% !important;

    .product-card {
      width: 32% !important;
      height: auto !important;

      .product-title {
        font-size: 16px !important;
      }

      .detail-btn {
        align-self: center !important;
        font-size: 14px !important;
        padding: 10px 0 !important;
      }

      .content-text {
        font-size: 12px !important;
      }
    }
  }
  /deep/.el-dialog__body{
    padding: 10px 20px !important;
  }
  /deep/.detail-text{
    max-height: 200px !important;
    font-size: 14px !important;
  }
}
</style>
